var _a;
import { handleActions } from 'redux-actions';
import { offerHotelsAction } from './actions';
export var offerHotelsReducer = handleActions((_a = {},
    _a[offerHotelsAction.toString()] = function (state, _a) {
        var payload = _a.payload;
        return payload;
    },
    _a), false);
